import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { ChangePasswordPageComponent } from './change-password-page.component';
import { FormsModule } from '@angular/forms';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.changePassword',
    url: '/changePassword',
    component: ChangePasswordPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      message: null,
      policyChangePasswordUpdate: false
    }
  }
];

@NgModule({
  declarations: [ChangePasswordPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [ChangePasswordPageComponent]
})
export class ChangePasswordPageModule { }
